export default __webpack_public_path__ + "static/media/editorMax.9b424843.svg";